import { render } from "./OpenChestRow.vue?vue&type=template&id=01aec440"
import script from "./OpenChestRow.vue?vue&type=script&lang=js"
export * from "./OpenChestRow.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__